import LegalPageLayout from "../components/layout/LegalPageLayout";
import termsEN from "../content/legal/terms-en";
import termsGR from "../content/legal/terms-gr";

const TermsOfService = () => {
  return (
    <LegalPageLayout
      contentEN={termsEN}
      contentGR={termsGR}
      titleKey="meta.terms.title"
      descriptionKey="meta.terms.description"
      path="/terms"
    />
  );
};

export default TermsOfService;
